<!-- ==================================== POPUP : Consultation Letter (STARTS) ============================================== -->

<div >
    <form [formGroup]="consultation">
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label> Select title </label>
  
            <i class="t-sep"></i>
  
            <span class="t-validation-wrap l-fg1">
              <select
                class="t-select w100"
                #Title
                formControlName="Title"
                (change)="changeTitle()"
                [ngClass]="!consultation.get('Title')?.value ? 'is-invalid' : ''"
              >
                <option value="" >Please select a title</option>
                <option value="Consultation Letter">Consultation Letter</option>
                <option *ngIf="ls?.premissions?.ConsultationFollowUpMedia" value="consultation and follow up with media">Consultation and Follow Up with Media</option>
                <option value="Visit Confirmation">Visit Confirmation</option>
                <option value="Visit Summary">Visit Summary</option>
                <option value="Summary And Visit Recommendation">
                  Summary And Visit Recommendation
                </option>
                <option value="Medical Prescription">Medical Prescription</option>
              </select>
              <div class="t-validation-message">
                <span>Please select a title</span>
              </div>
            </span>
          </div>
        </div>
        <div class="w50">
          <div class="l-flex l-flex-c t-field t-field-pad">
            <label> Select template </label>
  
            <i class="t-sep"></i>
  
            <span class="t-validation-wrap l-fg1">
              <select
                class="t-select w100"
                name="selectedTemplate"
                #selected
                (change)="setTemplate(selected.value);showEdit=false"
              >
                <option  value="" >Select a template</option>
                <option
                  *ngFor="let template of templates"
                  [value]="template.TemplateID"
                >
                  {{ template.Title }}
  
                  <div></div>
                </option>
              </select>
            </span>
            
            <img *ngIf="selected.value && showEdit" style="cursor: pointer; width: 1.4em; margin: 0 0.5em;"
              matTooltip="Update this template with the current content"
              src="../../assets/icons/edit.svg"
              (click)="showPopup=true" />
            <img *ngIf="selected.value" style="cursor: pointer; width: 1.4em; margin: 0 0.5em;"
              matTooltip="Delete template"
              src="../../assets/icons/delete-blue.svg"
              (click)="confirmDeleteTemplate(selected.value)" />
        
          </div>
        </div>
  
        <div class="w100 h100 summary-anamnesis">
          <section
            class="m-box fulltext"
            style="padding-bottom: 0; padding-top: 1.5em"
          >
            <h2 class="title">{{ es.ExamType }}</h2>
            <div
            style="
              display: flex;
              justify-content: end;
              height: 3em;
              align-items: center;
            "
          >
            <div
              style="
                display: flex;
                gap: 1em;
                align-items: center;
                margin-bottom: 1em;
              "
            >
              <input
                #titleValue
                name="titleValue"
                placeholder="Enter template title"
                type="text"
                class="w20 search-patient-field"
                style="background-color: #e5eef0; color: #015a6c; margin: 0"
                (input)="checkTextChanged(selected.value, titleValue.value)"
              />
              <button
                [disabled]="checkTemplate(titleValue.value)"
                (click)="createTemplate(titleValue.value)"
                class="orange-btn"
                style="min-width: 7em; height: 2em"
              >
                Add Template
              </button>
            </div>
          </div>
            <ckeditor
              #ckeditorRef
              class="scroller scroller-intro fulltext"
              formControlName="FormContent"
              style="width: 100%"
              [editor]="FormContentEditor"
              [config]="formContentEditorConfig"
              (change)="checkTextChanged(selected.value)"
            >
            </ckeditor>
            <button
              *ngIf="es.ExamType == 'consultation and follow up with media'"
              class="t-btn-edit"
              (click)="loadPreviousMedicalInfo()"
              style="margin-right: 7%; margin-bottom: 0.5em"
            >
              Import Previous Medical Information
            </button>
            <button
              *ngIf="es.ExamType == 'consultation and follow up with media'"
              class="t-btn-edit"
              (click)="loadLastMedicalInfo()"
              style="margin-right: 28%; margin-bottom: 0.5em"
            >
              Import Last Medical Information
            </button>
            <button
              *ngIf="!isClinicsExam"
              class="t-btn-edit"
              (click)="
                consultation.get('FormContent') && atS.showAuto(
                  consultation.get('FormContent')!,
                  'Consultation Letter',
                  91, true, true
                )
              "
              style="margin-bottom: 0.5em"
            >
              Auto Text
            </button>
            <button
              *ngIf="isClinicsExam"
              class="t-btn-edit clinics-autotext-sticky-btn"
              (click)="showAutotextPanel = true"
              style="margin-bottom: 0.5em"
            >
              Add Clinics AutoText
            </button>
          </section>
        </div>
      </div>
    </form>
    <div *ngIf="showPopup" class="t-popup popup-patientDetails popup-centered">
      <div class="t-popup-frame">
          <div class="t-popup-body">
  
              <button class="t-btn-popup-close" aria-label="close popup" (click)="showPopup=false"></button>
  
              <h2 style='color: #D7A95B; text-align: center;'>
                  You are about to override your current template.
                  <br>
                  Are you sure you want to continue?
              </h2>
              <div style="display: flex; justify-content: center;">
                  <button class="blue-btn" (click)="editTemplate(selected.value)">Yes</button>
                  <button class="orange-btn" style='margin-left: 2em' (click)="showPopup=false">No</button>
              </div>

          </div>
      </div>
    </div>

    <div *ngIf="showDeleteConfirm" class="t-popup popup-patientDetails popup-centered">
      <div class="t-popup-frame">
          <div class="t-popup-body">

              <button class="t-btn-popup-close" aria-label="close popup" (click)="showDeleteConfirm=false; templateToDelete=null"></button>

              <h2 style='color: #D7A95B; text-align: center;'>
                  Delete template "{{templateToDelete?.Title}}"?
                  <br>
                  This cannot be undone.
              </h2>
              <div style="display: flex; justify-content: center;">
                  <button class="blue-btn" (click)="deleteTemplate()">Yes</button>
                  <button class="orange-btn" style='margin-left: 2em' (click)="showDeleteConfirm=false; templateToDelete=null">No</button>
              </div>

          </div>
      </div>
  </div>
  </div>
  
  <!-- of the three letter types on this page only a Clinics letter carries diagnoses -->
  <app-exam-diagnoses *ngIf="es.isClinicsExam"></app-exam-diagnoses>
  <app-exam-payer *ngIf="es.isClinicsExam" [examId]="es.examID"></app-exam-payer>
  <app-gastro-summary [signOnly]="true"></app-gastro-summary>
  
  <div class="second-layer-popup">
    <div class="second-layer-popup-frame">
      <div class="second-layer-popup-body"></div>
    </div>
  </div>
  <app-autotext *ngIf="atS.Display"></app-autotext>
  <app-autotext-panel
    [display]="showAutotextPanel"
    [snippets]="myAutoTextLists"
    (insert)="insertAutotextSnippet($event)"
    (close)="showAutotextPanel = false"
  ></app-autotext-panel>